<template>
  <v-list nav dense>
    <v-list-item-group v-model="locale" color="globalBlue">
      <v-list-item
        v-for="locale in locales"
        :key="locale.code"
        @click="setLocale(locale.code)"
        :value="locale.code"
      >
        <v-list-item-content>
          <v-list-item-title class="body-2 font-weight-regular">{{
            locale.name.toUpperCase()
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-item-group>
  </v-list>
</template>

<script>
import { loadLanguageAsync } from "@/plugins/i18n.js";
import { getSupportedLocales } from "@/helpers/i18n/supported-locales";

export default {
  name: "LocaleSwitcher",
  data: () => ({
    locales: getSupportedLocales(),
    locale: "",
  }),
  methods: {
    async setLocale(locale) {
      if (locale) {
        await loadLanguageAsync(locale);
        this.$store.commit("UPDATE_LOCALE", locale);
        this.$vuetify.lang.current = locale;
        this.$ls.set("locale", locale);
      }
    },
  },
  mounted() {
    this.locale = this.$i18n.locale;
  },
};
</script>

<style></style>
